module.exports = __webpack_public_path__ + "a94dce3800793ee284e968df11871503.MP3";